import { render, staticRenderFns } from "./crypto.vue?vue&type=template&id=09adb300&scoped=true&"
import script from "./crypto.vue?vue&type=script&lang=ts&"
export * from "./crypto.vue?vue&type=script&lang=ts&"
import style0 from "./crypto.vue?vue&type=style&index=0&id=09adb300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09adb300",
  null
  
)

export default component.exports